import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { moderateChatMessage } from '../other/chatModeration';
import { onValue, push, off, child, update } from "firebase/database";

// Marca como "leído" los mensajes de la otra parte: guarda en la reserva la
// marca de tiempo de lectura por rol para mostrar doble chulito real.
export const updateChatRead = (bookingId, role) => () => {
    const { singleBookingRef } = firebase;
    if (!bookingId || !role) return;
    try {
        // El rechazo de la promesa (p. ej. PERMISSION_DENIED) debe capturarse con
        // .catch; el try/catch solo atrapa errores síncronos. Sin esto, una
        // escritura denegada generaba la caja roja "Operación no completada".
        const p = update(singleBookingRef(bookingId), { ['chatRead/' + role]: Date.now() });
        if (p && typeof p.catch === 'function') p.catch(() => { });
    } catch (e) { }
};

export const fetchChatMessages = (bookingId) => (dispatch) => {

    const {
        chatRef
    } = firebase;
  
    dispatch({
        type: FETCH_MESSAGES,
        payload: bookingId,
    });
    off(chatRef(bookingId));
    onValue(chatRef(bookingId), snapshot => {
        if(snapshot.val()){
            let rootEntry = snapshot.val();
            let allMesseges = [];
            for (let key in rootEntry) {
                let entryKey = rootEntry[key]
                for (let msgKey in entryKey) {
                  entryKey[msgKey].smsId = msgKey
                  allMesseges.push(entryKey[msgKey])
                }
            }
            allMesseges.sort((a, b) => {
                const ta = a.createdAt ? Date.parse(a.createdAt) : 0;
                const tb = b.createdAt ? Date.parse(b.createdAt) : 0;
                return ta - tb;
            });
            dispatch({
                type: FETCH_MESSAGES_SUCCESS,
                payload: allMesseges,
            });
        }else{
            dispatch({
                type: FETCH_MESSAGES_SUCCESS,
                payload: [],
            });
        }
    })
};

export const sendMessage = (data) => (dispatch) => {

    const {
        chatRef
    } = firebase;

    const authUid = store.getState().auth?.profile?.uid;
    if (!data || !data.booking || !data.booking.id || !data.role || !data.message || !authUid) {
        return Promise.resolve(false);
    }

    const moderation = moderateChatMessage(data.message);
    if (!moderation.allowed) {
        return Promise.resolve({ ok: false, reason: moderation.reason });
    }

    const customerId = data.booking.customer || (data.role === 'customer' ? authUid : null);
    if (!customerId) {
        return Promise.resolve(false);
    }

    // Misma sala para cliente y conductor: customerId + driverId (o pending).
    let driverId = data.booking.driver;
    if (!driverId && data.role === 'driver') {
        driverId = authUid;
    }
    if (!driverId) {
        driverId = 'pending';
    }
    const chatId = customerId + ',' + driverId;
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); 
    var yyyy = today.getFullYear();
    today = mm + ':' + dd + ':' + yyyy;
    
    const msg = {
        message:data.message,
        from: authUid,
        type:"msg",
        msgDate:today,
        msgTime:time,
        createdAt: new Date().toISOString(),
        source: data.role
    };

    try {
        const p = push(child(chatRef(data.booking.id), chatId), msg);
        if (p && typeof p.catch === 'function') p.catch((e) => { console.log('sendMessage error', e); });
    } catch (e) { console.log('sendMessage error', e); }

    if(data.role == 'customer'){
        if(data.booking.driver_token){
            RequestPushMsg(
                data.booking.driver_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id, status: data.booking.status || 'ACCEPTED' }
                });
        }
    }else{
        if(data.booking.customer_token){
            RequestPushMsg(
                data.booking.customer_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id, status: data.booking.status || 'ACCEPTED' }
                });
        }
    }

    dispatch({
        type: SEND_MESSAGE,
        payload: msg,
    });
    return Promise.resolve({ ok: true });
}

export const stopFetchMessages = (bookingId) => (dispatch) => {

    const {
        chatRef 
    } = firebase;

    dispatch({
        type: STOP_FETCH_MESSAGES,
        payload: bookingId,
    });
    off(chatRef(bookingId));
}